import React, { useEffect, useState } from 'react';
import { chamSocKhachHangApi } from '../../../api/chamSocKhachHangApi';
import { useCommonContext } from '../../../contexts/common';
import PhuHuynhCSKHItem from '../../phu-huynh-cskh-item';
import styles from "./CSKHHistory.module.css";
import { useSelector } from 'react-redux';
const CSKHHistory = ({ ts_phuhuynh_id, ts_hocsinh_id, ts_hoso_survey_id, changedCount, onChanged }) => {
    const [chamSocKhachHangs, setChamSocKhachHangs] = useState([]);
    const { translate } = useCommonContext();
    const { dm_coso_id } = useSelector((x) => x.coSo);
    useEffect(() => {
        handleReloadData();
    }, [ts_phuhuynh_id, ts_hocsinh_id, ts_hoso_survey_id, changedCount])
    const handleReloadData = async () => {
        const res = await chamSocKhachHangApi.Select({
            ts_phuhuynh_id,
            ts_hocsinh_id,
            ts_hoso_survey_id,
            dm_coso_id
        });
        setChamSocKhachHangs(res.data);

    }
    return (
        <div>
            {chamSocKhachHangs.length == 0 &&
                <div className={styles.no_data}>
                    <p>{translate("Không có dữ liệu lịch sử chăm sóc")}</p>
                </div>
            }
            {chamSocKhachHangs.length > 0 &&
                <div className={styles.list_container}>
                    {chamSocKhachHangs.map((ts_chamsockhachhang, idx) => {
                        return <PhuHuynhCSKHItem
                            key={idx}
                            ts_chamsockhachhang={ts_chamsockhachhang}
                            onChanged={() => {
                                handleReloadData();
                                if (onChanged) {
                                    onChanged();
                                }
                            }}
                        />
                    })}
                </div>
            }
        </div>
    );
};

export default CSKHHistory;